// 域名配置工具
// 根据不同的域名返回对应的名称、favicon和title配置

const domainConfigs = {
  localhost: {
    name: "悦韵",
    title: "悦韵人工智能教学平台",
    favicon: '/favicon2.ico',
    key: "yueyun",
  },
  "ai.teachmusic.cn": {
    name: "灵智鸟",
    title: "灵智鸟人工智能教学平台",
    favicon: '/favicon.ico',
    key: "lingzhiniao",
  },
  "aiedu.teachmusic.cn": {
    name: "悦韵",
    title: "悦韵人工智能教学平台",
    favicon: '/favicon2.ico',
    key: "yueyun",
  },
}

/**
 * 获取当前域名对应的配置
 * @returns {Object} 返回包含名称的对象
 */
export function getDomainConfig() {
  const hostname = window.location.hostname

  // 先查找完整匹配
  if (domainConfigs[hostname]) {
    return domainConfigs[hostname]
  }

  // 查找部分匹配（如子域名）
  for (const [domain, config] of Object.entries(domainConfigs)) {
    if (hostname.includes(domain)) {
      return config
    }
  }

  // 默认返回localhost配置
  return domainConfigs["localhost"]
}

/**
 * 获取当前域名对应的名称
 * @returns {string} 网站名称
 */
export function getDomainName() {
  return getDomainConfig().name
}

/**
 * 获取当前域名对应的key
 * @returns {string} 域名key
 */
export function getDomainKey() {
  return getDomainConfig().key
}

/**
 * 获取当前域名对应的页面标题
 * @returns {string} 页面标题
 */
export function getDomainTitle() {
  return getDomainConfig().title
}

/**
 * 获取当前域名对应的favicon路径
 * @returns {string} favicon路径
 */
export function getDomainFavicon() {
  return getDomainConfig().favicon
}

/**
 * 更新页面标题和favicon
 * 这个方法应该在应用初始化时调用
 */
export function updatePageMeta() {
  // 更新页面标题
  document.title = getDomainTitle()
  
  // 更新favicon
  const faviconPath = getDomainFavicon()
  let faviconLink = document.querySelector('link[rel*="icon"]')
  
  if (faviconLink) {
    faviconLink.href = faviconPath
  } else {
    // 如果没有找到favicon link，创建一个新的
    faviconLink = document.createElement('link')
    faviconLink.rel = 'icon'
    faviconLink.href = faviconPath
    document.head.appendChild(faviconLink)
  }
}

/**
 * 检查是否为特定域名
 * @param {string} domainKey - 要检查的域名key
 * @returns {boolean} 是否为指定域名
 */
export function isDomain(domainKey) {
  return getDomainKey() === domainKey
}

// 默认导出
export default {
  getDomainConfig,
  getDomainName,
  getDomainKey,
  getDomainTitle,
  getDomainFavicon,
  updatePageMeta,
  isDomain,
}
